module.exports = __webpack_public_path__ + "img/bn.6fe646d3.jpg";